import { BrowserRouter } from "react-router-dom";
import { render } from "react-dom";
import App from "./App";

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css'
import { createRoot } from 'react-dom/client'
import React from 'react'

const root = createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
